const NUMERIC = new Set(["price_per_meter", "qty_hq", "width", "length", "height", "gross_weight"]);
const FIELDS = ["item_number", "name_cn", "size", "factory", "quote_date", "quote_customer", "thickness", "remark", "others", "others_details", "salesperson", "profit_tax", "processing_fee", "brand_paper", "plastic_bag", "price_per_meter", "material_size", "carton_freight", "liner_board", "packing_rate", "qty_hq", "gross_weight", "width", "length", "height", "tag"];

export function pqValue(key, value) {
  if (key === "others_details") return value || [];
  if (NUMERIC.has(key)) return Number(value || 0);
  return String(value ?? "");
}

// Only changed fields travel to the API. Base values reject same-field conflicts.
export function pqChanges(draft, base) {
  const changes = {}, base_values = {};
  for (const key of FIELDS) {
    if (!(key in draft)) continue;
    const value = pqValue(key, draft[key]);
    if (JSON.stringify(value) === JSON.stringify(pqValue(key, base[key]))) continue;
    changes[key] = value;
    base_values[key] = base[key] ?? null;
  }
  return Object.keys(changes).length ? { ...changes, base_values } : null;
}
